<div class="container">
  <mic-breadcrumb id="finished-product-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('finishedProductText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="m-0 mt-3" id="finished-product-heading">{{ translationService.translate('finishedProductText') }}</h3>

  <div class="action-bar">
    <button id="reset-filters" type="button" mat-flat-button color="accent" (click)="clearFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <span [matTooltip]="isAssignDisabled ? translationService.translate('selectProductsText') : ''" matTooltipPosition="above">
      <button
        id="assign-to-plants"
        type="button"
        mat-flat-button
        class="btn-primary"
        (click)="showAssignPlantModel()"
        [disabled]="!saveEnabled || isAssignDisabled"
      >
        <mat-icon>assignment_turned_in</mat-icon>
        {{ translationService.translate('assignToPlantText') }}
      </button>
    </span>
    <span
      [matTooltip]="
        productSaveDisabled
          ? this.translationService.translate('comingSoonText')
          : !saveEnabled
          ? this.translationService.translate('userCannotSaveText')
          : !isModified
          ? this.translationService.translate('noModifiedText')
          : null
      "
      matTooltipPosition="above"
    >
      <button id="save" type="button" mat-flat-button class="btn-primary" (click)="save()" [disabled]="!saveEnabled || !isModified">
        <mat-icon>save</mat-icon>
        {{ translationService.translate('saveLinkText') }}
      </button>
    </span>
    @if (!isProduction) {
    <button id="export-button-top" mat-flat-button class="btn-export" (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
    }
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-spec-dropdown
          [id]="'michelinStatus'"
          [options]="michelinStatusList"
          [formGroup]="filterForm"
          [controlName]="'michelinStatus'"
          [label]="translationService.translate('michelinStatusText')"
          [editMode]="true"
          [placeholder]="translationService.translate('searchByText') + ' ' + translationService.translate('michelinStatusText')"
        ></app-spec-dropdown>
        <app-spec-dropdown
          [id]="'plantAssignment'"
          [options]="plantAssignmentList"
          [formGroup]="filterForm"
          [controlName]="'plantAssignment'"
          [label]="translationService.translate('plantAssignmentColumnText')"
          [editMode]="true"
          [placeholder]="'Select ' + translationService.translate('plantAssignmentColumnText')"
        ></app-spec-dropdown>
        <app-spec-dropdown
          [id]="'cureType'"
          [options]="cureTypeList"
          [formGroup]="filterForm"
          [controlName]="'cureType'"
          [label]="translationService.translate('cureTypeText')"
          [editMode]="true"
          [placeholder]="'Select ' + translationService.translate('cureTypeText')"
        ></app-spec-dropdown>

        <mic-dropdown-search
          micDropdownAccessibility
          id="tread"
          formControlName="treads"
          [data]="treadList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectTreadText') }}"
          label="{{ translationService.translate('treadText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="treadWidth"
          formControlName="treadWidth"
          [data]="treadWidthList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectTreadWidthText') }}"
          label="{{ translationService.translate('treadWidthText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="size"
          formControlName="size"
          [data]="sizeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('selectSizeText') }}"
          label="{{ translationService.translate('sizeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  @if (isExporting) {
  <mic-spinner id="finished-product-export-spinner" ariaLabel="In Progress" color="primary" [strokeWidth]="5"></mic-spinner>
  }

  <div id="finished-product-table" class="cam-table table-container">
    <div class="table-inner">
      <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
            <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
          </button>
          <mat-menu #colMenu="matMenu">
            <div
              class="column-menu-content column-menu-list"
              cdkDropList
              [cdkDropListData]="columnOrder"
              (cdkDropListDropped)="onColumnDrop($event)"
            >
              @for (key of columnOrder; track key) {
              <div class="column-menu-item" cdkDrag>
                <mat-icon class="column-drag-handle" cdkDragHandle aria-hidden="true">drag_indicator</mat-icon>
                <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">
                  {{ columnNames[key] || key }}
                </mat-checkbox>
              </div>
              }
            </div>
          </mat-menu>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerRetreadNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [widthConfig]="dropdownWidthConfig"
            [virtualScroll]="true"
            [data]="getDropdownData(item, 'dealerRetreadNo')"
            [formControl]="getControl(item, 'dealerRetreadNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerRetreadNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerCapNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [data]="getDropdownData(item, 'dealerCapNo')"
            [widthConfig]="dropdownWidthConfig"
            [formControl]="getControl(item, 'dealerCapNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerCapNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerCasingNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="dropdownWidthConfig"
            [data]="getDropdownData(item, 'dealerCasingNo')"
            [formControl]="getControl(item, 'dealerCasingNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerCasingNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerCapAndCasingNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="dropdownWidthConfig"
            [data]="getDropdownData(item, 'dealerCapAndCasingNo')"
            [formControl]="getControl(item, 'dealerCapAndCasingNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerCapAndCasingNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerAdRetreadNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="dropdownWidthConfig"
            [data]="getDropdownData(item, 'dealerAdRetreadNo')"
            [formControl]="getControl(item, 'dealerAdRetreadNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerAdRetreadNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerAdCapNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="dropdownWidthConfig"
            [data]="getDropdownData(item, 'dealerAdCapNo')"
            [formControl]="getControl(item, 'dealerAdCapNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerAdCapNo')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'dealerAdCapAndCasingNoDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [virtualScroll]="true"
            [widthConfig]="dropdownWidthConfig"
            [data]="getDropdownData(item, 'dealerAdCasingNo')"
            [formControl]="getControl(item, 'dealerAdCasingNo')"
            (mousedown)="onDropdownCellClick(item, 'dealerAdCasingNo')"
          ></mic-dropdown-search>
        </ng-container>
      </mic-table>
    </div>
    <mic-modal class="modalC" #viewAssignPlant style="height: 30%" (result)="onAssignPlantModalClosed($event)"></mic-modal>
    <ng-template #assignedToPlant>
      <mic-table id="plant-table" class="table-stripped" [config]="tableConfig2" [dataSource]="plantDataSource">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
        </ng-container>
      </mic-table>
    </ng-template>
  </div>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
